export const ProohFormDataTargets = {
  // Prooh
  sellerCreateMediaForm: "seller-create-media-form",
  sendConfirmationForm: "send-confirmation-form",
  addCaptiveAreaForm: "add-poi-captive-area-form",
  tabContentPreviewForm: "tab-content-preview-form",
  viewMediaImagesFrom: "view-media-images-from",
};

// Prooh/Toohl Lit Status
export const ToohlLitStatusValues = {
  FRONT_LIT: "Front-Lit",
  BACK_LIT: "Back-Lit",
  NOT_LIT: "Non-Lit",
  AMBIENT_LIT: "Ambient-Lit",
  DIGITAL: "Digital-Screen",
};
